import request from '@/utils/request'


// 获取省
export function getProvinces() {
  return request({
    url: '/platformCommon/getProvinces',
    method: 'get',
  })
}

// 获取市(根据省名称)
export function getCityByProNames(data) {
  return request({
    url: '/platformCommon/getCityByProNames',
    method: 'get',
    params: data
  })
}

// 获取市(根据省ID)
export function getCityByProIds(data) {
  return request({
    url: '/platformCommon/getCityByProIds',
    method: 'get',
    params: data
  })
}
// 获取区
export function getAreaByCityId(data) {
  return request({
    url: '/platformCommon/getAreaByCityId',
    method: 'get',
    params: data
  })
}

// 获取街道
export function getStreetByAreaId(data) {
  return request({
    url: '/platformCommon/getStreetByAreaId',
    method: 'get',
    params: data
  })
}

// 获取街道
export function getDistinctStreet(data) {
  return request({
    url: '/address/getDistinctStreet',
    method: 'get',
    params: data
  })
}


// 获取所有的省市区
export function getAllAreaNoStreet() {
  return request({
    url: '/common/getAllAreaNoStreet',
    method: 'get'
  })
}

// 获取所有产品线
export function getAllProductLine() {
  return request({
    url: '/platformCommon/getAllProductLineList',
    method: 'get'
  })
}

// 获取所有银行
export function AllBanks() {
  return request({
    url: '/platformCommon/getAllBank',
    method: 'get',
  })
}

// 获取平台所有角色
export function getPlatformMemberRoles() {
  return request({
    url: '/platformCommon/getPlatformMemberRoles',
    method: 'get',
  })
}

// 获取厂家所有角色
export function getFactoryRoles() {
  return request({
    url: '/factoryEmployee/getFactoryRoles',
    method: 'get',
  })
}

// 获取所有品牌商
export function getAllFactory() {
  return request({
    url: '/platformCommon/getAllFactory',
    method: 'get',
  })
}

// 获取所有服务商
export function getAllSite() {
  return request({
    url: '/platformCommon/getAllSite',
    method: 'get',
  })
}

// 获取所有品牌
export function getAllBrand(query) {
  return request({
    url: '/platformCommon/getAllBrand',
    method: 'get',
    params: query
  })
}

// 获取所有对接人
export function getAllMeetPeople() {
  return request({
    url: '/dianjiang/factorySet/getAllMeetPeople',
    method: 'get',
  })
}

// 获取所有产品线
export function getAllProductLineList() {
  return request({
    url: '/platformCommon/getAllProductLineList',
    method: 'get',
  })
}


// 根据产品线获取产品品类
export function getCategoryByProductLine(productLineId) {
  return request({
    url: '/platformCommon/getCategoryByProductLine/'+ productLineId,
    method: 'get',
  })
}

// 根据产品线名称获取产品品类
export function getCategoryByProductLineName(data) {
  return request({
    url: '/platformCommon/getCategoryByProductLineName',
    method: 'get',
    params: data
  })
}

// 根据服务类型获取服务措施
export function getServiceByType(type) {
  return request({
    url: '/platformCommon/getServiceByType/'+ type,
    method: 'get',
  })
}


// 获取所有省市省街道
export function getAllArea() {
  return request({
    url: '/platformCommon/getAllArea',
    method: 'get',
  })
}

// 获取平台维护的所有品类
export function getAllCategory() {
  return request({
    url: '/platformCommon/getAllCategory',
    method: 'get',
  })
}

// 获取动态查询条件设置
export function queryConditionSet(query) {
  return request({
    url: '/conditionSet/getCondition',
    method: 'get',
    params: query
  })
}

// 修改查询时获取用户之前的设置
export function editConditionSet(query) {
  return request({
    url: '/conditionSet/getUserSetCondition',
    method: 'get',
    params: query
  })
}
// 保存设置的条件查询
export function saveConditionSet(data) {
  return request({
    url: '/conditionSet/saveUserSetCondition',
    method: 'POST',
    data: data
  })
}

// 修改时获取表头设置信息
export function getheadSettingDetail(pathName) {
  return request({
    url: '/tableHeader/headSettingDetail/'+ pathName,
    method: 'get',
  })
}

// 保存设置的表头信息
export function saveHeadSetting(data) {
  return request({
    url: '/tableHeader/saveHeadSetting',
    method: 'POST',
    data: data
  })
}

// 获取动态表头设置
export function editHeadSetting(query) {
  return request({
    url: '/tableHeader/getHeadSetting',
    method: 'get',
    params: query
  })
}

// 获取下拉中的标记类型
export function getOrderFlag() {
  return request({
    url: '/platformCommon/getOrderFlag',
    method: 'get',
  })
}

// 购买渠道
export function getbuyList(query) {
  return request({
    url: '/orderCommon/getBuyWay',
    method: 'get',
    params: query
  })
}

// 获取所有物流名称
export function getAllLogistics(query) {
  return request({
    url: '/platformCommon/getAllLogistics',
    method: 'get',
    params: query
  })
}

// 信息员姓名下拉
export function getMessengerMan() {
  return request({
    url: '/orderCommon/getMessengerMan',
    method: 'get',
  })
}
